module.exports = __webpack_public_path__ + "static/media/view vehicle.09e836a5.svg";